function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "#231F20"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 8.1c.7 0 1.2-.5 1.2-1.2V.2L.5 8.1H8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.4 20.8l-3.2.6h-.1c-.2 0-.3 0-.4-.1-.1-.1-.2-.3-.3-.4l-.6-3.1c0-.2 0-.3.1-.5l4.6-7v-9c0-.7-.6-1.2-1.2-1.2h-6.6V7c0 1.4-1.1 2.5-2.5 2.5H.3v13.2c0 .7.6 1.2 1.2 1.2h15.7c.7 0 1.2-.6 1.2-1.2v-1.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.1 8.5c-.5 0-1 .3-1.4.7l-5.6 8.6v.2l.4 1.9c0 .1.2.2.3.2l1.9-.4c.1 0 .1-.1.2-.1l5.6-8.5c.5-.8.3-1.8-.4-2.3-.4-.2-.7-.3-1-.3z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;